import React from "react";
import { useParams, Link } from "react-router-dom";
import { UpcomingData } from "../Components/upcomingData";
const Featured_Products = (props) => {
  const { productId } = useParams();
  const product = UpcomingData.find((e) => e.id === parseInt(productId));
  return (
    <div className="single-product">
      <div className="detail-card">
        <img src={product.img} alt="" />
        <h3>{product.name}</h3>
        <i className="fa fa-star gold"></i>
        <i className="fa fa-star gold"></i>
        <i className="fa fa-star gold"></i>
        <i className="fa fa-star gold"></i>
        <i className="fa fa-star-half half-star"></i>
        <span className="price-badge">${(0.8 * product.price).toFixed(2)}</span>
        <span className="old-price">${product.price}</span>
        <h4>20% off</h4>
        <span className="delivery">
          ${product.delivery}
          <span className="w-700 size-16 m-5p">Delivery to Pakistan</span>
        </span>
        <Link
          className="btn btn-buy"
          to="/payments"
          onClick={() =>
            props.handlePrice(
              product.price * 0.8 + product.delivery,
              product.id
            )
          }
        >
          Buy
        </Link>
        <button
          className="btn btn-cart btn-sm"
          onClick={() => props.handleAdded(product)}
        >
          Add to cart
        </button>
      </div>
      <Link className="btn btn-link" to="/products">
        Back to products
      </Link>
    </div>
  );
};
export default Featured_Products;
